import React, { useEffect } from 'react';
import Navbar from '../component/Navbar/NavbarCommon';
import ArrowButton from '../component/Common/ArrowButton';
import { useLocation } from 'react-router-dom';

const Brands: React.FC = () => {
  const location = useLocation();

  // Scroll to anchor if hash is present in the location
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        // small timeout to ensure page layout is ready
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 50);
      }
    } else {
      // scroll to top on page open without hash
      window.scrollTo({ top: 0 });
    }
  }, [location.hash]);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <main className="max-w-5xl mx-auto px-6 py-24 mt-14">
        <div className="mb-6">
          <ArrowButton />
        </div>
        <h1 className="text-3xl font-semibold text-gray-900 mb-8 text-center">Brands</h1>

        {/* A. O. Smith Section */}
        <section id="ao-smith" className="mb-12">
          <div className="flex items-center gap-6 mb-6">
            {/* Use the project's logo if available */}
            <img src="assets/logo-2.png" alt="A. O. Smith" className="h-auto w-auto object-contain" />
            {/* <img src="/assets/150year.png" alt="150 years" className="h-16 w-auto object-contain" /> */}
          </div>

          <p className="text-gray-800 leading-relaxed mb-4">
            With 150 plus years of legacy, A. O. Smith prides itself on applying innovative technology
            and energy-efficient solutions to water technology products marketed worldwide. The
            company focuses heavily on new product development, global expansion, strategic
            acquisitions and partnerships to achieve this goal.
          </p>

          <p className="text-gray-800 leading-relaxed mb-4">
            In water heating, we are one of the leading brands in India, pioneering innovation, and
            offering the best in the industry. In the water purification, A. O. Smith is a preferred brand
            for the affluent urban consumers who are matured in their life-stage and intend to upgrade
            to the best in class water purifier. The brand stands for innovation, and world class service
            enhancing the lifestyle of its consumers.
          </p>
        </section>

        {/* Pureit Section */}
        <section id="pureit" className="mb-12">
          <div className="flex items-center gap-6 mb-6">
              <img src="assets/pureit_water_logo.png" alt="Pureit" className="h-auto w-auto object-contain" />
            {/* Pureit logo is not present in assets; use a placeholder graphic/text */}
            {/* <div className="h-20 w-32 flex items-center justify-center bg-gray-100 rounded-md">
              <span className="text-lg font-semibold">Pureit</span>
            </div> */}
          </div>

          <p className="text-gray-800 leading-relaxed mb-4">
            Pureit was first launched in Chennai in 2004 with the introduction of Pureit Classic, a first-
            of-its-kind gravity-based water purifier to provide accessible and safe drinking water to
            millions. It was launched nationwide in 2008. It entered the Electric Water purification
            segment in 2011 and further strengthened the portfolio in this segment. Pureit continued
            to launch disruptive consumer-centric devices such as Copper RO – Worlds first RO with
            patented Copper Charge™ technology in 2019. Later in 2022 and 2023, Pureit launched new
            platforms with FiltraPower™ and DURAViva™ technologies. Pureit operates in India,
            Bangladesh, Sri Lanka, Vietnam, and Mexico, among others.
          </p>

          <p className="text-gray-800 leading-relaxed mb-4">
            Built over 15 years of technological expertise, Pureit offers a wide range of advanced RO
            and UV water purifiers to deliver 100% safe and healthy drinking water, making it
            accessible to every Indian household. With its high-class purification technology, it
            enriches water with nutrients inspired by nature and modern science.
          </p>

          <p className="text-gray-800 leading-relaxed">
            Pureit brand resonates with urban consumers, relatively early in their life-stage, intending
            to enter the category. Pureit products exuberate high performance delivering peace of mind
            and essential features and benefits. Pureit aims to be widely available across geographic
            regions going beyond the tier 1 urban agglomerates.
          </p>
        </section>
      </main>
    </div>
  );
};

export default Brands;
